import { render, staticRenderFns } from "./ThinSkinWarningModal.vue?vue&type=template&id=35460d57&scoped=true"
import script from "./ThinSkinWarningModal.vue?vue&type=script&lang=js"
export * from "./ThinSkinWarningModal.vue?vue&type=script&lang=js"
import style0 from "./ThinSkinWarningModal.vue?vue&type=style&index=0&id=35460d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35460d57",
  null
  
)

export default component.exports